import React from 'react';
import { formatCurrency } from 'src/utils/stringUtils';
import classNames from 'classnames';

import styles from './pointPrice.module.css';

type PointPriceProps = {
  price: number;
  isActive: boolean;
  isVisited: boolean;
};

const PointPrice = (props: PointPriceProps) => {
  const { price, isActive, isVisited } = props;
  return (
    <div
      className={classNames(styles.price, {
        [styles.activePrice]: isActive,
        [styles.visitedPrice]: isVisited,
      })}
    >
      {formatCurrency(price)}
    </div>
  );
};

export default PointPrice;
